import { detectIE } from 'lib/helpers';

function setIEBodyClass() {
  if (detectIE() !== false && !document.body.classList.contains('IE')) {
    document.body.classList.add('IE');
  }
}
setIEBodyClass();
window.addEventListener('turbolinks:load', setIEBodyClass);
